<script>
  // @ts-check
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import { capitalize } from "@sourcewhale/shared/src/assets/js/src/general/utils";

  /**
    @typedef {Object} Props
    @property {string} [style=""] - The style of the status tag.
    @property {import ("../utils").MarketingLicense} license - The license type to display.
    @property {import("svelte").Snippet<[any]>} [children] - Optional children to render inside the tag.
  */

  /** @type {Props} */
  let { style, license, children } = $props();
  let mod = $derived(capitalize(license));
  let cls = $derived(`background-color-module${mod}_5 color-module${mod}_50`);
</script>

<StatusTag {style} class={cls} size="large" kind="">
  <h4>
    {#if children}
      {@render children()}
    {:else}
      {mod}
    {/if}
  </h4>
</StatusTag>
